import React, {useState, useEffect, useContext} from "react";
import { getReproductions, getReproductionsByUser } from "../../../api/reproductionApi";
import ReproWheel from "./adminReproductionWheel";
import { changeReproductionStatus, changeReproductionStatusE } from "../../../api/reproductionApi";
import { AuthContext } from "../../../Contexts/AuthContext";
import './ReproStyle.css';

export const AdminReproduction = () => {
  const { user } = useContext(AuthContext);
  const [reproductions, setReproductions] = useState([]);
  const [loading, setLoading] = useState(true);
  const isEleveur = user?.role === 'eleveur';

  useEffect(() => {
    loadReproductions();
  }, [isEleveur, user?.id]);

  const loadReproductions = () => {
    setLoading(true);
    const request = isEleveur ? getReproductionsByUser(user.id) : getReproductions();
    request
      .then(data => setReproductions(data))
      .finally(() => setLoading(false));
  };

  const handleStatusChange = async (id, newStatus, preserveDates = false) => {
    try {
      if (isEleveur) {
        await changeReproductionStatusE(id, newStatus, preserveDates);
      } else {
        await changeReproductionStatus(id, newStatus, preserveDates);
      }
      const fresh = isEleveur ? await getReproductionsByUser(user.id) : await getReproductions();
      setReproductions(fresh);
    } catch (err) {
      console.error("Status change failed:", err);
      throw err;
    }
  };

  return (
    <div className="rp-page">
      <ReproWheel reproductions={reproductions} onStatusChange={handleStatusChange} loading={loading} />
    </div>
  );
};